import React from 'react';
import "./GetStarted.css";

function GetStarted() {
  return (
    <section className="g-wrapper" id='getStarted'>
        <div className="paddings innerWidth g-container">
            <div className="flexColCenter inner-container">
                <span className='primaryText'>Get Started With Aura</span>
                <span className='secondaryText'>Subscribe & Find Attractive Quotes From Us
                    <br />
                    Find Your Property Soon!
                </span>

                <button className='button'>
                    <a href="mailto:ajinkyagavali4@gmail.com">Get Started</a>
                </button>
            </div>
        </div>
    </section>
  )
}

export default GetStarted
